// 法务处理
import request from '@/router/axios';

// 列表
export const getLegalCollectionList = (current, size, params) => {
  return request({
    url: '/api/v2/blade-loanPost/loan/legalCollectionList',
    method: 'post',
    data: {
      ...params,
      current,
      size,
    },
  });
};

// 确认收款
export const subLegalCollectionConfirmation = row => {
  return request({
    url: '/api/v2/blade-loanPost/loan/legalCollectionConfirmation',
    method: 'post',
    data: row,
  });
};
// 客户还租收款
export const subLegalCollectionCustomConfirmation = row => {
  return request({
    url: '/api/v2/blade-loanPost/loan/legalCollectionCustomConfirmation',
    method: 'post',
    data: row,
  });
};

// 法务收款详情
export const getLegalCollectionDetail = row => {
  return request({
    url: '/api/v2/blade-loanPost/loan/legalCollectionDetail',
    method: 'post',
    data: row,
  });
};

// 法务 客户还租详情
export const getLegalCollectionCustomDetail = row => {
  return request({
    url: '/api/v2/blade-loanPost/loan/legalCollectionCustomDetail',
    method: 'post',
    data: row,
  });
};